// extracted by mini-css-extract-plugin
export default {"gainfulbutton":"IN","borderRadius":"JN","disabled":"KN","widthFourty":"LN","widthSixty":"MN","fullwidth":"NN","accountEditSubscriptionBtn":"ON","accountRdBtn":"PN","accountProductBtn":"QN","accountBannerBtn":"RN","upProductTopBanner":"SN","upProductGainfulTile":"TN","disabledBtn":"UN","buttonsmall":"VN","buttonlarge":"WN","buttonxlarge":"XN","high":"YN"};
    if(module.hot) {
      // 1721922365147
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  